import { SelectHTMLAttributes } from "react";
import { useAssetNumbers, useLotNumbers } from "../queries";
import { useFillerClassifications } from "@/queries/menu.queries";

type FillerMatrixLookupProps = SelectHTMLAttributes<HTMLSelectElement> & {
  process: string;
  wpsNumber: string;
};

export function FillerMatrixLookup({ process, wpsNumber, ...props }: FillerMatrixLookupProps) {
  const lookup = useFillerClassifications(process, wpsNumber);

  return (
    <select className="form-select" {...props}>
      <option />
      {lookup.data?.map((option) => (
        <option key={option}>{option}</option>
      ))}
    </select>
  );
}

type LotNumberLookupProps = SelectHTMLAttributes<HTMLSelectElement> & {
  process: string;
  classification: string;
};

export function LotNumberLookup({ process, classification, ...props }: LotNumberLookupProps) {
  const lookup = useLotNumbers(process, classification);
  return (
    <select className="form-select" {...props}>
      <option />
      {lookup.data?.map((option) => (
        <option key={option}>{option}</option>
      ))}
    </select>
  );
}

type AssetNumberLookupProps = SelectHTMLAttributes<HTMLSelectElement> & {
  process: string;
};

export function AssetNumberLookup(props: AssetNumberLookupProps) {
  const lookup = useAssetNumbers(props.process);
  return (
    <select className="form-select" {...props}>
      <option />
      {lookup.data?.map((option) => (
        <option key={option}>{option}</option>
      ))}
    </select>
  );
}
